module.exports = __webpack_public_path__ + "img/mp.2469ae78.svg";